// Recovered compiled webpack factory 69190. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "createRouterCacheKey", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(65360);
  function a(e, t) {
    return (void 0 === t && (t = !1), Array.isArray(e))
      ? e[0] + "|" + e[1] + "|" + e[2]
      : t && e.startsWith(n.PAGE_SEGMENT_KEY)
        ? n.PAGE_SEGMENT_KEY
        : e;
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
